import React, { useEffect, useState } from "react";
import { toast } from "sonner";
import { api } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Timer } from "@phosphor-icons/react";

const FIELDS = [
  ["new_minutes", "Traspaso nuevo (min)", "El agente aún no ha respondido la conversación.", 120],
  ["attended_minutes", "Ya atendida o asignada a mano (min)", "Un agente ya atendió y el cliente vuelve a escribir, o la asignó un supervisor.", 240],
  ["alert_after", "Avisar al supervisor tras (reasignaciones)", "Reasignaciones seguidas sin que ningún agente responda.", 10],
];

export const ReassignSettings = ({ canEdit }) => {
  const [cfg, setCfg] = useState(null);
  const [saving, setSaving] = useState(false);

  useEffect(() => { api.get("/settings/reassign").then(({ data }) => setCfg(data)).catch(() => setCfg(null)); }, []);

  const save = async () => {
    setSaving(true);
    try {
      const { data } = await api.put("/settings/reassign", cfg);
      setCfg(data);
      toast.success("Tiempos de reasignación guardados");
    } catch (e) {
      toast.error(e?.response?.data?.detail?.[0]?.msg || "Valores no válidos");
    } finally { setSaving(false); }
  };

  if (!cfg) return null;
  return (
    <div className="rounded-md border border-border p-4 mb-6" data-testid="reassign-settings">
      <div className="flex items-center gap-1.5 text-sm font-semibold mb-1"><Timer size={14} /> Reasignación por falta de respuesta</div>
      <p className="text-xs text-muted-foreground mb-4">
        Si el agente asignado no responde en este tiempo, la conversación pasa al siguiente agente conectado del equipo, sin perder el historial.
      </p>
      <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
        {FIELDS.map(([k, label, help, max]) => (
          <div key={k}>
            <Label className="text-xs">{label}</Label>
            <Input type="number" min={1} max={max} value={cfg[k]} disabled={!canEdit}
              onChange={(e) => setCfg({ ...cfg, [k]: Number(e.target.value) })} data-testid={`reassign-${k}`} />
            <p className="text-[11px] text-muted-foreground mt-1">{help}</p>
          </div>
        ))}
      </div>
      {canEdit && (
        <Button size="sm" className="mt-4" onClick={save} disabled={saving} data-testid="reassign-save">
          {saving ? "Guardando…" : "Guardar"}
        </Button>
      )}
    </div>
  );
};

export default ReassignSettings;
